import { validationLength } from "../components/actions/validations";

const reserveNameFieldMax = validationLength.roomFeatureName;
const reservePasswordMax = validationLength.retailUserSetupPassword;

/** Default (non-error) helper text under Reserve User Details fields. */
export const reserveUserDetailsFieldHelperText = {
  firstName: `Max ${validationLength.firstName} characters; letters, numbers and spaces only; no special characters. Optional.`,
  lastName: `Max ${validationLength.lastName} characters; letters, numbers and spaces only; no special characters. Optional.`,
  countryCode: `Digits only; max 4 characters. Optional.`,
  mobile: "10-digit phone number (digits only). Optional.",
  emailAddress:
    "Enter a valid email address (e.g. user@example.com). Mandatory.",
  employeeCode: `Max ${reserveNameFieldMax} characters; line breaks not allowed. Mandatory.`,
  username: `Max ${reserveNameFieldMax} characters; line breaks not allowed. Mandatory.`,
  password: `Max ${reservePasswordMax} characters; special characters allowed; line breaks not allowed. Mandatory.`,
  pin: `Max ${reservePasswordMax} characters; special characters allowed; line breaks not allowed. Optional.`,
  role: "Select a role defined on the Roles screen. Mandatory.",
} as const;

/** Error helper text (shown in red when field validation fails). */
export const reserveUserDetailsFieldErrors = {
  required: "This field is required.",
  firstName: `Max ${validationLength.firstName} characters; letters, numbers and spaces only; no special characters.`,
  lastName: `Max ${validationLength.lastName} characters; letters, numbers and spaces only; no special characters.`,
  countryCode: "Digits only; max 4 characters.",
  mobile: "Enter a 10-digit phone number.",
  emailInvalid: "Enter a valid email address.",
  employeeCode: `Max ${reserveNameFieldMax} characters; line breaks not allowed.`,
  username: `Max ${reserveNameFieldMax} characters; line breaks not allowed.`,
  password: `Max ${reservePasswordMax} characters; line breaks not allowed.`,
  pin: `Max ${reservePasswordMax} characters; line breaks not allowed.`,
} as const;

const ratePlanFieldMax = validationLength.departmentName;

/** Default (non-error) helper text under Reserve Rate Plan fields. */
export const reserveRatePlanFieldHelperText = {
  activityName: `Max ${ratePlanFieldMax} characters; letters, numbers and spaces only; no special characters. Mandatory.`,
  basePrice: `Max ${ratePlanFieldMax} characters; special characters allowed; line breaks not allowed. Mandatory.`,
  guestTypePricing: `Max ${ratePlanFieldMax} characters; special characters allowed; line breaks allowed. Optional.`,
  hourlyPrice: `Max ${ratePlanFieldMax} characters; special characters allowed; line breaks not allowed. Optional.`,
  dailyWeekly: `Max ${ratePlanFieldMax} characters; special characters allowed; line breaks allowed. Optional.`,
} as const;

/** Error helper text (shown in red when Rate Plan field validation fails). */
export const reserveRatePlanFieldErrors = {
  required: "This field is required.",
  activityName: `Max ${ratePlanFieldMax} characters; letters, numbers and spaces only; no special characters.`,
  basePrice: `Max ${ratePlanFieldMax} characters; line breaks not allowed.`,
  guestTypePricing: `Max ${ratePlanFieldMax} characters total.`,
  hourlyPrice: `Max ${ratePlanFieldMax} characters; line breaks not allowed.`,
  dailyWeekly: `Max ${ratePlanFieldMax} characters total.`,
} as const;

/** Default (non-error) helper text under Reserve Instructors fields. */
export const reserveInstructorsFieldHelperText = {
  firstName: `Max ${validationLength.firstName} characters; letters, numbers and spaces only; no special characters. Mandatory.`,
  lastName: `Max ${validationLength.lastName} characters; letters, numbers and spaces only; no special characters. Mandatory.`,
  employeeCode: `Max ${reserveNameFieldMax} characters; line breaks not allowed. Mandatory.`,
  expertiseLevel: "Select None or Trainer. Mandatory.",
  countryCode: "Digits only; max 4 characters. Optional.",
  mobile: "10-digit phone number (digits only). Optional.",
  emailAddress:
    "Enter a valid email address (e.g. user@example.com). Optional.",
} as const;

/** Error helper text (shown in red when Instructors field validation fails). */
export const reserveInstructorsFieldErrors = {
  required: "This field is required.",
  firstName: `Max ${validationLength.firstName} characters; letters, numbers and spaces only; no special characters.`,
  lastName: `Max ${validationLength.lastName} characters; letters, numbers and spaces only; no special characters.`,
  employeeCode: `Max ${reserveNameFieldMax} characters; line breaks not allowed.`,
  expertiseLevel: "Select an expertise level (None or Trainer).",
  countryCode: "Digits only; max 4 characters.",
  mobile: "Enter a 10-digit phone number.",
  emailInvalid: "Enter a valid email address.",
} as const;
